import { Dictionary } from "lodash";

export interface ReportConfiguration {
    variableProperty?: string;
}

export type ReportOverrides = Dictionary<ReportConfiguration>;
